/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_Map_Legend_NeighborInputs */



/**
* | output |
* | --- |
* | "Neighbor link" |
*
* @param {Mesh_Map_Legend_NeighborInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_map_legend_neighbor = /** @type {((inputs?: Mesh_Map_Legend_NeighborInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Map_Legend_NeighborInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Neighbor link")
	return /** @type {LocalizedString} */ ("Lien voisin")
});